export const RESET_SUPPLIER_GROUP = 'RESET_SUPPLIER_GROUP'
